/* TEH · Rail + Editorial — loop continuo sin dependencias. Compatible con lazysizes T4 (Kalles). */
(function () {
  'use strict';
  if (window.TehRail) return;

  var MQ_MOBILE = window.matchMedia('(max-width: 767px)');
  var MQ_REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var DRAG_THRESHOLD = 6;

  function onMQ(mq, fn) { mq.addEventListener ? mq.addEventListener('change', fn) : mq.addListener(fn); }
  function offMQ(mq, fn) { mq.removeEventListener ? mq.removeEventListener('change', fn) : mq.removeListener(fn); }

  function TehRail(rail) {
    this.rail = rail;
    this.section = rail.closest('.teh-re');
    this.track = rail.querySelector('[data-teh-track]');
    this.dotsEls = this.section ? Array.prototype.slice.call(this.section.querySelectorAll('[data-teh-dots]')) : [];
    this.dots = [];
    this.activeDot = -1;
    this.tween = null;
    var d = rail.dataset;
    this.cfg = {
      autoplay: d.autoplay === 'true',
      autoplayMobile: d.autoplayMobile === 'true',
      dir: d.direction === 'right' ? -1 : 1,
      speed: parseFloat(d.speed) || 45,
      speedMobile: parseFloat(d.speedMobile) || 20,
      pauseHover: d.pauseHover !== 'false',
      drag: d.drag !== 'false'
    };
    this.originals = Array.prototype.slice.call(this.track.children);
    this.clones = [];
    this.offset = 0;
    this.period = 0;
    this.vel = 0;
    this.raf = 0;
    this.last = 0;
    this.pauses = {};
    this.mode = null;
    this.drag = null;

    var self = this;
    this._tick = function (t) { self.tick(t); };
    this._setup = function () { self.setup(); };
    this._vis = function () { self.pause('hidden', document.hidden); };
    this._enter = function () { if (self.cfg.pauseHover) self.pause('hover', true); };
    this._leave = function () { self.pause('hover', false); };
    this._fin = function () { self.pause('focus', true); };
    this._fout = function (e) { if (!self.rail.contains(e.relatedTarget)) self.pause('focus', false); };
    this._down = function (e) { self.onDown(e); };
    this._move = function (e) { self.onMove(e); };
    this._up = function (e) { self.onUp(e); };
    this._dragstart = function (e) { e.preventDefault(); };
    this._scroll = function () { if (self.mode === 'native') self.updateDots(); };

    rail.addEventListener('mouseenter', this._enter);
    rail.addEventListener('mouseleave', this._leave);
    rail.addEventListener('focusin', this._fin);
    rail.addEventListener('focusout', this._fout);
    rail.addEventListener('pointerdown', this._down);
    rail.addEventListener('dragstart', this._dragstart);
    document.addEventListener('visibilitychange', this._vis);
    rail.addEventListener('scroll', this._scroll, { passive: true });
    onMQ(MQ_MOBILE, this._setup);
    onMQ(MQ_REDUCED, this._setup);

    if ('IntersectionObserver' in window) {
      this.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          self.pause('offscreen', !en.isIntersecting);
          if (en.isIntersecting) self.warmImages();
        });
      }, { rootMargin: '300px 0px' });
      this.io.observe(rail);
    }
    if ('ResizeObserver' in window) {
      var timer;
      this.ro = new ResizeObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(function () { if (self.mode === 'engine') self.measure(); }, 150);
      });
      this.ro.observe(rail);
    }
    this.revealSlide();
    this.buildDots();
    this.setup();
  }

  TehRail.prototype.isMobile = function () { return MQ_MOBILE.matches; };

  TehRail.prototype.motionOn = function () {
    if (MQ_REDUCED.matches) return false;
    return this.isMobile() ? this.cfg.autoplayMobile : this.cfg.autoplay;
  };

  TehRail.prototype.setup = function () {
    var native = this.isMobile() && !this.cfg.autoplayMobile;
    this.removeClones();
    this.stop();
    this.offset = 0;
    this.vel = 0;
    this.track.style.transform = '';
    this.rail.classList.toggle('is-native', native);
    if (this.section) this.section.classList.toggle('no-motion', !this.motionOn());
    if (native) { this.mode = 'native'; this.updateDots(); return; }
    this.mode = 'engine';
    this.measure();
    if (this.warmed && !this.clonesWanted) this.waitRendered();
    this.start();
  };

  TehRail.prototype.measure = function () {
    if (!this.originals.length) return;
    var first = this.originals[0];
    var lastEl = this.originals[this.originals.length - 1];
    var mr = parseFloat(getComputedStyle(lastEl).marginRight) || 0;
    var period = lastEl.offsetLeft + lastEl.offsetWidth + mr - first.offsetLeft;
    if (period <= 0) return;
    var ratio = this.period ? this.offset / this.period : 0;
    this.period = period;
    this.offset = ratio * period;
    if (this.clonesWanted) this.ensureClones();
    this.activeDot = -1;
    this.render();
  };

  /* Las copias para el loop se crean cuando el tema ya renderizó las imágenes
     de los productos originales (data-rendert4s), así no se duplican peticiones. */
  TehRail.prototype.ensureClones = function () {
    this.clonesWanted = true;
    if (this.mode !== 'engine' || !this.period) return;
    var viewport = this.rail.clientWidth;
    var copiesNeeded = Math.max(1, Math.ceil(viewport / this.period)); // contenido >= periodo + viewport
    var have = this.clones.length / this.originals.length;
    for (var c = have; c < copiesNeeded; c++) this.addCopy();
  };

  TehRail.prototype.waitRendered = function () {
    var self = this, tries = 0;
    if (this._waiting || this.clonesWanted) return;
    this._waiting = true;
    (function check() {
      tries++;
      var pending = 0;
      for (var i = 0; i < self.originals.length; i++) {
        var r = self.originals[i].querySelectorAll('[data-rendert4s]');
        for (var j = 0; j < r.length; j++) if (!r[j].classList.contains('lazyloadt4sed')) pending++;
      }
      if (!pending || tries > 12) { self._waiting = false; self.ensureClones(); return; }
      self._waitTimer = setTimeout(check, 400);
    })();
  };

  TehRail.prototype.addCopy = function () {
    var frag = document.createDocumentFragment();
    for (var i = 0; i < this.originals.length; i++) {
      var node = this.originals[i].cloneNode(true);
      node.setAttribute('aria-hidden', 'true');
      node.removeAttribute('id');
      // Si el original estaba a mitad de carga (lazysizes), la copia vuelve a estado "por cargar"
      var busy = node.querySelectorAll('.lazyloadt4sing');
      for (var b = 0; b < busy.length; b++) {
        var el = busy[b];
        el.classList.remove('lazyloadt4sing');
        el.classList.add('lazyloadt4s');
        if (el.hasAttribute('data-bgset')) {
          var pics = el.querySelectorAll('picture');
          for (var q = 0; q < pics.length; q++) if (pics[q].parentNode === el) pics[q].remove();
        }
      }
      var ids = node.querySelectorAll('[id]');
      for (var k = 0; k < ids.length; k++) ids[k].removeAttribute('id');
      var links = node.querySelectorAll('a, button, input, select');
      for (var j = 0; j < links.length; j++) links[j].setAttribute('tabindex', '-1');
      this.clones.push(node);
      frag.appendChild(node);
    }
    this.track.appendChild(frag);
    if (this.warmed) this.warmImages();
  };

  TehRail.prototype.removeClones = function () {
    for (var i = 0; i < this.clones.length; i++) this.clones[i].remove();
    this.clones = [];
  };

  /* Las imágenes fuera del viewport horizontal no disparan lazy-load nativo:
     cuando el módulo se acerca al viewport, se piden todas (son livianas). */
  TehRail.prototype.warmImages = function () {
    var self = this;
    var LS = window.lazySizesT4;
    var unveil = function (el) {
      el.classList.add('lazypreloadt4s'); // preloadClass del tema (lazysizes T4)
      // Fuerza la carga aunque esté fuera del área visible del carrusel (overflow hidden)
      if (LS && LS.loader && LS.loader.unveil && !el.classList.contains('lazyloadt4sed') && !el.classList.contains('lazyloadt4sing')) {
        try { LS.loader.unveil(el); } catch (err) {}
      }
    };
    var mark = function (root) {
      if (root.classList && root.classList.contains('lazyloadt4s')) unveil(root);
      var lz = root.querySelectorAll('.lazyloadt4s');
      for (var i = 0; i < lz.length; i++) unveil(lz[i]);
      var imgs = root.querySelectorAll('img[loading="lazy"]');
      for (var j = 0; j < imgs.length; j++) imgs[j].loading = 'eager';
    };
    mark(this.track);
    if (!this.warmed) {
      this.warmed = true;
      // El tema inyecta el HTML de la imagen del producto después (view=img): marcar lo nuevo también
      if ('MutationObserver' in window) {
        this.mo = new MutationObserver(function (list) {
          for (var i = 0; i < list.length; i++) {
            var added = list[i].addedNodes;
            for (var j = 0; j < added.length; j++) if (added[j].nodeType === 1) {
              mark(added[j]);
            }
          }
        });
        this.mo.observe(this.track, { childList: true, subtree: true });
      }
      if (this.mode === 'engine') this.waitRendered();
    }
  };

  /* Animaciones del banner (ani_img / ani_txt) del tema se activan con .is-selected (Flickity);
     aquí se agrega cuando el banner entra en pantalla. */
  TehRail.prototype.revealSlide = function () {
    var slide = this.section && this.section.querySelector('[data-teh-slide]');
    if (!slide) return;
    if (!('IntersectionObserver' in window) || window.Shopify && Shopify.designMode) { slide.classList.add('is-selected'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { slide.classList.add('is-selected'); io.disconnect(); } });
    }, { threshold: 0.2 });
    io.observe(slide);
    this.slideIO = io;
  };

  TehRail.prototype.pause = function (reason, on) {
    if (on) this.pauses[reason] = true; else delete this.pauses[reason];
    this.start();
  };

  TehRail.prototype.isPaused = function () {
    for (var k in this.pauses) if (this.pauses[k]) return true;
    return false;
  };

  /* ---------- Dots ---------- */
  TehRail.prototype.buildDots = function () {
    var self = this, n = this.originals.length;
    this.dots = [];
    if (!this.dotsEls.length || n < 2) return;
    for (var i = 0; i < n; i++) this.dots.push([]);
    this.dotsEls.forEach(function (box) {
      box.innerHTML = '';
      for (var i = 0; i < n; i++) {
        (function (k) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'teh-re__dot';
          b.setAttribute('aria-label', 'Ir al producto ' + (k + 1) + ' de ' + n);
          b.addEventListener('click', function () { self.goTo(k); });
          box.appendChild(b);
          self.dots[k].push(b);
        })(i);
      }
    });
    this.activeDot = -1;
    this.updateDots();
  };

  TehRail.prototype.itemWidth = function () {
    var n = this.originals.length;
    if (this.mode === 'engine' && this.period) return this.period / n;
    var a = this.originals[0], b = this.originals[1];
    return b ? (b.offsetLeft - a.offsetLeft) : (a ? a.offsetWidth : 0);
  };

  TehRail.prototype.updateDots = function () {
    if (!this.dots.length) return;
    var w = this.itemWidth(), n = this.originals.length;
    if (!w) return;
    var pos = this.mode === 'engine' ? this.offset : this.rail.scrollLeft;
    var idx = ((Math.round(pos / w) % n) + n) % n;
    if (idx === this.activeDot) return;
    (this.dots[this.activeDot] || []).forEach(function (d) { d.classList.remove('is-active'); d.removeAttribute('aria-current'); });
    this.dots[idx].forEach(function (d) { d.classList.add('is-active'); d.setAttribute('aria-current', 'true'); });
    this.activeDot = idx;
  };

  TehRail.prototype.goTo = function (k) {
    var w = this.itemWidth();
    if (!w) return;
    if (this.mode === 'native') {
      this.rail.scrollTo({ left: k * w, behavior: MQ_REDUCED.matches ? 'auto' : 'smooth' });
      return;
    }
    this.ensureClones();
    var p = this.period, target = k * w;
    var delta = ((target - this.offset) % p + p) % p;   // camino más corto dentro del loop
    if (delta > p / 2) delta -= p;
    this.vel = 0;
    this.tween = { from: this.offset, delta: delta, start: performance.now(), dur: MQ_REDUCED.matches ? 1 : 650 };
    // tras saltar, deja el producto a la vista un momento antes de retomar el movimiento
    var self = this;
    this.pause('jump', true);
    clearTimeout(this._jumpTimer);
    this._jumpTimer = setTimeout(function () { self.pause('jump', false); }, 2600);
    this.start();
  };

  TehRail.prototype.shouldRun = function () {
    if (this.mode !== 'engine' || !this.period) return false;
    if (this.drag && this.drag.active) return true;
    if (this.tween) return true;
    if (Math.abs(this.vel) > 4) return true;
    return this.motionOn() && !this.isPaused();
  };

  TehRail.prototype.start = function () {
    if (this.raf || !this.shouldRun()) return;
    this.last = performance.now();
    this.raf = requestAnimationFrame(this._tick);
  };

  TehRail.prototype.stop = function () {
    if (this.raf) cancelAnimationFrame(this.raf);
    this.raf = 0;
  };

  TehRail.prototype.tick = function (t) {
    this.raf = 0;
    var dt = Math.min(64, t - this.last) / 1000;
    this.last = t;
    if (this.tween && !(this.drag && this.drag.active)) {
      var tw = this.tween, k = Math.min(1, (t - tw.start) / tw.dur);
      var e = k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2; // easeInOutCubic
      this.offset = tw.from + tw.delta * e;
      if (k >= 1) this.tween = null;
      this.render();
    } else if (!(this.drag && this.drag.active)) {
      if (Math.abs(this.vel) > 4) {
        this.offset += this.vel * dt;
        this.vel *= Math.pow(0.04, dt); // inercia tras soltar
      } else {
        this.vel = 0;
        if (this.motionOn() && !this.isPaused()) {
          var sp = this.isMobile() ? this.cfg.speedMobile : this.cfg.speed;
          this.offset += this.cfg.dir * sp * dt;
        }
      }
      this.render();
    }
    if (this.shouldRun()) this.raf = requestAnimationFrame(this._tick);
  };

  TehRail.prototype.render = function () {
    var p = this.period;
    if (!p) return;
    if (!this.clones.length && (this.offset < 0 || this.offset > p - this.rail.clientWidth)) this.ensureClones();
    this.offset = ((this.offset % p) + p) % p;
    this.track.style.transform = 'translate3d(' + (-this.offset).toFixed(2) + 'px,0,0)';
    this.updateDots();
  };

  /* Drag / swipe */
  TehRail.prototype.onDown = function (e) {
    if (this.mode !== 'engine' || !this.cfg.drag) return;
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    this.ensureClones();
    this.tween = null;
    this.vel = 0;
    this.drag = { x: e.clientX, y: e.clientY, start: this.offset, active: false, id: e.pointerId, samples: [] };
    this.rail.addEventListener('pointermove', this._move);
    this.rail.addEventListener('pointerup', this._up);
    this.rail.addEventListener('pointercancel', this._up);
  };

  TehRail.prototype.onMove = function (e) {
    var d = this.drag;
    if (!d || e.pointerId !== d.id) return;
    var dx = e.clientX - d.x;
    if (!d.active) {
      if (Math.abs(e.clientY - d.y) > Math.abs(dx)) { if (Math.abs(e.clientY - d.y) > DRAG_THRESHOLD) this.onUp(e); return; }
      if (Math.abs(dx) < DRAG_THRESHOLD) return;
      d.active = true;
      try { this.rail.setPointerCapture(d.id); } catch (err) {}
      this.rail.classList.add('is-dragging');
      this.pause('drag', true);
    }
    this.offset = d.start - dx;
    this.render();
    var now = performance.now();
    d.samples.push({ t: now, x: e.clientX });
    while (d.samples.length > 2 && now - d.samples[0].t > 100) d.samples.shift();
  };

  TehRail.prototype.onUp = function (e) {
    var d = this.drag;
    this.rail.removeEventListener('pointermove', this._move);
    this.rail.removeEventListener('pointerup', this._up);
    this.rail.removeEventListener('pointercancel', this._up);
    if (!d) return;
    this.drag = null;
    if (d.active) {
      var s = d.samples;
      if (s.length > 1) {
        var a = s[0], b = s[s.length - 1];
        var dt = (b.t - a.t) / 1000;
        if (dt > 0) this.vel = Math.max(-2500, Math.min(2500, -(b.x - a.x) / dt));
      }
      this.rail.classList.remove('is-dragging');
      // Evita que el arrastre dispare el click del producto
      var rail = this.rail;
      var block = function (ev) { ev.preventDefault(); ev.stopPropagation(); rail.removeEventListener('click', block, true); };
      rail.addEventListener('click', block, true);
      setTimeout(function () { rail.removeEventListener('click', block, true); }, 50);
      try { this.rail.releasePointerCapture(d.id); } catch (err) {}
    }
    this.pause('drag', false);
    this.start();
  };

  TehRail.prototype.destroy = function () {
    this.stop();
    this.removeClones();
    this.track.style.transform = '';
    var r = this.rail;
    r.removeEventListener('mouseenter', this._enter);
    r.removeEventListener('mouseleave', this._leave);
    r.removeEventListener('focusin', this._fin);
    r.removeEventListener('focusout', this._fout);
    r.removeEventListener('pointerdown', this._down);
    r.removeEventListener('dragstart', this._dragstart);
    document.removeEventListener('visibilitychange', this._vis);
    r.removeEventListener('scroll', this._scroll);
    this.dotsEls.forEach(function (box) { box.innerHTML = ''; });
    offMQ(MQ_MOBILE, this._setup);
    offMQ(MQ_REDUCED, this._setup);
    if (this.io) this.io.disconnect();
    if (this.mo) this.mo.disconnect();
    if (this.slideIO) this.slideIO.disconnect();
    clearTimeout(this._waitTimer);
    clearTimeout(this._jumpTimer);
    if (this.ro) this.ro.disconnect();
    delete r._tehRail;
  };

  function init(scope) {
    var rails = (scope || document).querySelectorAll('[data-teh-rail]');
    for (var i = 0; i < rails.length; i++) if (!rails[i]._tehRail) rails[i]._tehRail = new TehRail(rails[i]);
  }
  function destroy(scope) {
    var rails = (scope || document).querySelectorAll('[data-teh-rail]');
    for (var i = 0; i < rails.length; i++) if (rails[i]._tehRail) rails[i]._tehRail.destroy();
  }

  window.TehRail = { init: init, destroy: destroy };

  // Theme Editor de Shopify
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var s = e.target && e.target.closest && e.target.closest('[data-teh-slide]');
    if (s) s.classList.add('is-selected');
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();
